export default __webpack_public_path__ + "media/Loved-Ones.c892d42d.svg";